"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTestUsersProgressStatSummaryToJSON = exports.GetTestUsersProgressStatSummaryFromJSONTyped = exports.GetTestUsersProgressStatSummaryFromJSON = void 0;
var runtime_1 = require("../runtime");
function GetTestUsersProgressStatSummaryFromJSON(json) {
    return GetTestUsersProgressStatSummaryFromJSONTyped(json, false);
}
exports.GetTestUsersProgressStatSummaryFromJSON = GetTestUsersProgressStatSummaryFromJSON;
function GetTestUsersProgressStatSummaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventType': json['eventType'],
        'progress': json['progress'],
        'target': json['target'],
        'rewardId': json['rewardId'],
        'userStatId': json['userStatId'],
        'gameId': !(0, runtime_1.exists)(json, 'gameId') ? undefined : json['gameId'],
    };
}
exports.GetTestUsersProgressStatSummaryFromJSONTyped = GetTestUsersProgressStatSummaryFromJSONTyped;
function GetTestUsersProgressStatSummaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventType': value.eventType,
        'progress': value.progress,
        'target': value.target,
        'rewardId': value.rewardId,
        'userStatId': value.userStatId,
        'gameId': value.gameId,
    };
}
exports.GetTestUsersProgressStatSummaryToJSON = GetTestUsersProgressStatSummaryToJSON;
